import { useEffect, useMemo } from 'react'
import { skipToken, useSuspenseQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'
import { goodie } from '@guestgoodie/helpers'
import { Session } from '@guestgoodie/auth-core'

import { client } from './useSuspendedSession'

export default function useSuspendedInit(session: Session | null) {
  const { data, error } = useSuspenseQuery(
    AdminAPI.init.GET_INIT,
    !session
      ? skipToken
      : {
          fetchPolicy: 'no-cache',
          variables: {
            // Since it is possible that we don't have the organization yet, for example when just signing up we should skip it in this case
            skipOrg: !session.currentOrgId
          }
        }
  )

  // Let's set the Currency directly so it will be set everywhere automatically
  if (data?.getBranding) {
    goodie.setCurrentCurrency(data.getBranding.currency)
  }

  const currentUser = useMemo(() => {
    if (!data) return null

    return getFragment(SharedAPI.user.USER_FRAGMENT, data.me)
  }, [data])

  useEffect(() => {
    if (error) client.signOut()
  }, [error])

  return {
    currentUser
  }
}
